module.exports = __webpack_public_path__ + "static/media/8.52a9e2a5.jpg";